import MaterialLinearProgress, {
    LinearProgressProps,
} from '@mui/material/LinearProgress';

export function LinearProgress(props: LinearProgressProps) {
    return (
        <MaterialLinearProgress
            data-testid={'LinearProgress-container'}
            {...props}
        />
    );
}

export default LinearProgress;
